module.exports = __webpack_public_path__ + "static/media/table.22b88aca.less";